import { render, staticRenderFns } from "./DateNavigation.vue?vue&type=template&id=36ec3835&scoped=true&"
import script from "./DateNavigation.vue?vue&type=script&lang=js&"
export * from "./DateNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ec3835",
  null
  
)

export default component.exports